module.exports = __webpack_public_path__ + "img/welcome-text.26698d63.svg";